// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__yGF8z","load3":"Spinner_load3__DP+ua"};